import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Forces a refresh of the Cognito Session.
 * This triggers the Pre-Token Generation Lambda to run again.
 */
export async function forceTokenRefresh() {
  try {
    // v6: built-in flag to bypass cache and get fresh tokens
    const session = await fetchAuthSession({ forceRefresh: true });
    return session;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    throw error;
  }
}
